module.exports = __webpack_public_path__ + "static/media/crocodile(14).d03c5f1b.PNG";